export default {
  haulers: 'Tegljači',
  setup: 'Postavljanje',
  driverExperience: 'Iskustvo vozača',
  users: 'Korisnici',
};
